
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cbre-table-title',
  styleUrl: './table-title.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <div class="cbre-table-title-container fx--h">
      <span class="cbre-table-title-container__title"> {{ title() }} </span>
      @if (count() != null) {
        <span class="cbre-table-title-container__count">
          {{ count() }} <span class="cbre-table-title-container__count--semi-bold">Results</span>
        </span>
      }
    </div>
    `,
})
export class TableTitleComponent {
  readonly title = input('');
  readonly count = input<number>();
}
